// Generated by scripts/update-seeq-icons.js from src/svg/seeq/version-log.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcVersionLog = {
  prefix: 'fak',
  iconName: 'version-log' as IconName,
  icon: [
    915,
    1024,
    [],
    'e9be',
    'M68.6 953.9v-878.1l4.3-4.3h387.4v231.7h231.6v74.4c10.7 3.2 68.6 12.4 68.6-1.5v-120.1l-255.9-256h-504.6v1024h423.1v-65.8h-350.2l-4.3-4.3zM814.8 635v-98.7c0-46.8-48.2-110-92.8-124.5-80.7-26.3-173.1 42-173.1 124.5v98.7h-100v377.5h466v-377.5h-100.1zM594.7 550.6c0-4.8 5.9-26.1 8-32 24.9-69.8 114.6-78.6 149.7-11.4 2.6 4.9 10.9 25.3 10.9 29.1v98.7h-164.4l-4.3-4.3v-80.1zM866.3 958.2h-368.9v-268.9h368.9v268.9z',
  ],
} satisfies IconDefinition;
